export default class MyIssue {

    constructor() {
        this.id = ""
        this.appliance = {
            id: null,
            name: ""
        }
        this.order = null
        this.orderKey = null
        this.comment = ""
        this.createdAt = ""
        this.createdBy = {
            id: null,
            name: ""
        }
    }

    /**
     * @param response
     * @returns {MyIssue}
     */
    static buildFromResponse(response) {
        let entity = new this
        entity.id = response.id
        entity.appliance.id = response.appliance.id
        entity.appliance.name = response.appliance.name
        entity.order = response.order
        entity.orderKey = response.orderKey
        entity.comment = response.comment
        entity.createdAt = response.createdAt
        entity.createdBy.id = response.createdBy.id
        entity.createdBy.name = response.createdBy.name
        return entity
    }

}
